<template>
  <div id="app">
    <div class="container">
      <TheToolbar />
      <main class="content">
        <RouterView />
      </main>
    </div>
    <QrScanner v-if="ui.qrScannerActive" />
  </div>
</template>

<script setup lang="ts">
import TheToolbar from './components/TheToolbar.vue'
import QrScanner from './components/QrScanner.vue'
import { useUIStore } from './stores/ui'

const ui = useUIStore()
</script>

<style scoped>
.container {
  display: flex;
  flex-direction: column;
  height: 100vh;
}

.top {
  height: 80px;
  flex-shrink: 0;
}

.content {
  flex: 1;
  overflow-y: auto;
  padding: 1rem;
}
</style>
